function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonnelManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m121 94.409v30h-61v206.591h30v-176.591h31v30h40.518c2.373 4.966 5.156 9.741 8.291 14.297l-20.273 35.127 77.959 45 20.068-34.819c5.566.498 11.309.498 16.875 0l20.068 34.819 77.959-45-20.273-35.127c3.135-4.556 5.918-9.331 8.291-14.297h40.517v-30h31v176.591h30v-206.591h-61v-30h-40.518c-2.373-4.966-5.156-9.741-8.291-14.282l20.274-35.127-77.959-45-20.068 34.805c-5.566-.498-11.309-.498-16.875 0l-20.069-34.805-77.959 45 20.273 35.127c-3.135 4.541-5.918 9.316-8.291 14.282zm135 0c24.814 0 45 20.186 45 45s-20.186 45-45 45-45-20.186-45-45 20.186-45 45-45z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 407,
    r: 45,
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150 497c0-24.814-20.186-45-45-45h-60c-24.814 0-45 20.186-45 45v15h150z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437,
    cy: 407,
    r: 45,
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 452h-60c-24.814 0-45 20.186-45 45v15h150v-15c0-24.814-20.186-45-45-45z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.629 306.395-85.606 85.605h155.977v-30h-83.555l34.395-34.395z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 452h84.258l-34.395 34.395 21.211 21.21 85.606-85.605h-156.68z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelManagement);
export default __webpack_public_path__ + "static/media/personnel_management.932422aa9d8b96430a62dad96c82621d.svg";
export { ForwardRef as ReactComponent };